import { render, staticRenderFns } from "./PDPPricingCard.vue?vue&type=template&id=712ce9f3&scoped=true&"
import script from "./PDPPricingCard.vue?vue&type=script&lang=js&"
export * from "./PDPPricingCard.vue?vue&type=script&lang=js&"
import style0 from "./PDPPricingCard.vue?vue&type=style&index=0&id=712ce9f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712ce9f3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealBannerContent: require('/app/appsumo/nuxt/components/pdp/DealBannerContent.vue').default,ListingTypeLogo: require('/app/appsumo/nuxt/components/pdp/ListingTypeLogo.vue').default,TacoRating: require('/app/appsumo/nuxt/components/TacoRating.vue').default,Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default,DealUpsellCallout: require('/app/appsumo/nuxt/components/pdp/util/DealUpsellCallout.vue').default,PricingCardGuaranteeWrapper: require('/app/appsumo/nuxt/components/pdp/PricingCardGuaranteeWrapper.vue').default,PDPTimer: require('/app/appsumo/nuxt/components/pdp/util/PDPTimer.vue').default})
